import React, { Component } from 'react'
import styled from 'styled-components'
import defaultTheme from '@ntuctech/devex-tangram/Theme/defaultTheme'
import Text from '../Text/Text'
import { SCREEN_SIZE } from '../../lib/Media'
import ProductCollection from '../ProductCollection'
import Loader from '../Loader/Loader'
import { get, headers } from '../../lib/fetch'
import Carousel from '../Carousel/Carousel'
import isEmpty from 'lodash/isEmpty'
import { generateQueryString } from '../../lib/filterFormatter'
import Link from 'next/link'
import Router from 'next/router'

import { getConfigFor } from '../../utils/configService'
import { SPLIT_FEATURES } from '../../utils/constants'

const LOC_OFFERS = 'ProductWidget-Offers'

const OfferWrapper = styled.div`
  padding: 1rem 1rem 0.875rem 1rem;
  background-color: #ffffff;
  ${SCREEN_SIZE.From.Tablet} {
    padding: 1rem 2rem 1.375rem 2rem;
  }
  ${SCREEN_SIZE.From.Desktop} {
    padding-left: 2.5625rem;
  }
  ${SCREEN_SIZE.From.Hd} {
    padding-left: 3.5rem;
  }
  ${SCREEN_SIZE.Below.Tablet} {
    .productCollection {
      margin-bottom: 0;
    }
  }
  .productCollection {
    margin-bottom: 0;
  }
`

const OfferHeading = styled.div`
  display: flex;
  padding-bottom: 0.5rem;
`

const FreeProductsWrapper = styled.div`
  margin: 0.5rem 0;
`

const FreeProduct = styled.li`
  max-width: 25rem;
  display: inline-flex;
  align-items: center;
  white-space: normal;
`

const FreeProductImageContainer = styled.div`
  display: inline-block;
  width: 4rem;
  overflow: hidden;
  border: 1px solid #eaeaea;
  border-radius: 4px;
  flex-shrink: 0;
  > img {
    width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
`

const FreeProductStyledText = styled(Text)`
  margin: 1rem;
  vertical-align: top;
  display: inline-block;
  text-decoration: none;
  color: #333;
`

const MemberIngestionDiv = styled.div`
  display: flex;
`

const LPIcon = styled.img`
  margin-left: ${props => props.left};
  margin-right: ${props => props.right};
  width: ${props => props.width};
  height: ${props => props.height};
`

const DigitalClubPromo = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.25rem;
  ${SCREEN_SIZE.From.Tablet} {
    justify-content: start;
  }
`

const RedeemLabelDiv = styled.div`
  cursor: pointer;
  text-decoration: none;
  ${SCREEN_SIZE.From.Tablet} {
    margin-left: 0.5rem;
  }
`

class OfferDetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      offer: {},
      loading: true,
    }

    this.fetchOfferDetails = this.fetchOfferDetails.bind(this)
  }

  async fetchOfferDetails() {
    const userKey = window?.__NEXT_DATA__?.props?.userKey

    // GSR- 657
    const productEndpoint = 'product-offer/' + this.props.id
    if (this.props.id) {
      let buyProducts,
        buyCategories,
        buyBrands,
        buyTags,
        freeProducts,
        hideOffer
      try {
        const apiQueries = {
          includeTagDetails: true,
          storeId:
            this.props.checkoutAddress && this.props.checkoutAddress.storeId,
        }
        apiQueries.hasStock = 1
        const productApi = `${productEndpoint}${generateQueryString(
          apiQueries,
          true
        )}`
        const productResp = await get(productApi, {
          headers: {
            ...headers(),
            'x-device-Id': userKey,
          },
        })
        const offerResp = productResp.data.offers
        let products =
          (offerResp.ruleDetail &&
            offerResp.ruleDetail.buy &&
            offerResp.ruleDetail.buy.products) ||
          []
        if (products && products.length > 0) {
          if (products.length === 1) {
            products = products.filter(item => item.id !== this.props.pid)
          }
          if (products.length > 0) {
            if (productResp.code === 200 && productResp.status === 'SUCCESS') {
              buyProducts = {
                collection: productResp.data,
              }
            }
          }
        }

        const categories =
          (offerResp &&
            offerResp.ruleDetail &&
            offerResp.ruleDetail.buy &&
            offerResp.ruleDetail.buy.categories) ||
          []
        if (categories.length > 0) {
          if (productResp.code === 200 && productResp.status === 'SUCCESS') {
            buyCategories = { collection: productResp.data }
          }
        }

        const brands =
          (offerResp &&
            offerResp.ruleDetail &&
            offerResp.ruleDetail.buy &&
            offerResp.ruleDetail.buy.brands) ||
          []
        if (brands.length > 0) {
          if (productResp.code === 200 && productResp.status === 'SUCCESS') {
            buyBrands = { collection: productResp.data }
          }
        }

        const tags =
          (offerResp &&
            offerResp.ruleDetail &&
            offerResp.ruleDetail.buy &&
            offerResp.ruleDetail.buy.tags) ||
          []
        if (tags.length > 0) {
          if (productResp.code === 200 && productResp.status === 'SUCCESS') {
            buyTags = { collection: productResp.data }
          }
        }
        if (
          offerResp &&
          offerResp.ruleDetail &&
          offerResp.ruleDetail.elementGroup &&
          offerResp.ruleDetail.elementGroup.length
        ) {
          freeProducts = offerResp.ruleDetail.elementGroup.reduce(
            (current, eg) => {
              const egFreeProd =
                eg?.get && eg?.get?.isFree
                  ? eg?.get?.products || []
                  : (eg?.get?.products || []).filter(prod => prod.isFree)
              return [...current, ...egFreeProd]
            },
            []
          )
          // Removing duplicate entries
          freeProducts = freeProducts.filter(
            (prod, index, arr) => index === arr.findIndex(p => p.id === prod.id)
          )
        } else {
          if (
            offerResp &&
            offerResp.ruleDetail &&
            offerResp.ruleDetail.get &&
            offerResp.ruleDetail.get.isFree
          ) {
            freeProducts = offerResp.ruleDetail.get.products || []
          } else if (
            offerResp &&
            offerResp.ruleDetail &&
            offerResp.ruleDetail.get &&
            offerResp.ruleDetail.get.products
          ) {
            freeProducts = offerResp.ruleDetail.get.products.filter(
              product => product.isFree
            )
          }
        }
        if (
          isEmpty(buyCategories) &&
          isEmpty(buyBrands) &&
          isEmpty(buyTags) &&
          (!buyProducts ||
            (buyProducts &&
              buyProducts.collection &&
              buyProducts.collection.product &&
              buyProducts.collection.product.length === 0)) &&
          isEmpty(freeProducts)
        ) {
          hideOffer = true
        } else {
          this.props.onOfferLoad && this.props.onOfferLoad(this.props.id)
        }
        this.setState({
          offer: offerResp,
          loading: false,
          buyProducts,
          buyCategories,
          buyBrands,
          buyTags,
          freeProducts,
          hideOffer,
        })
      } catch (error) {
        this.setState({ error: error, loading: false, hideOffer: true })
      }
    } else {
      this.setState({ loading: false, hideOffer: true })
    }
  }

  componentDidMount() {
    this.fetchOfferDetails()
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.id &&
      (prevProps.id !== this.props.id ||
        prevProps.pid !== this.props.pid ||
        prevProps.checkoutAddress.storeId !==
          this.props.checkoutAddress.storeId)
    ) {
      this.setState(
        {
          loading: true,
          offer: undefined,
          productCollection: {},
          buyCategories: {},
          buyBrands: {},
          buyTaggedProducts: {},
        },
        () => {
          this.fetchOfferDetails()
        }
      )
    }
  }

  render() {
    const {
      offer,
      hideOffer,
      buyProducts,
      buyCategories,
      buyBrands,
      buyTags,
      freeProducts,
      loading,
    } = this.state

    const { data } = this.props

    const { configuration: digitalClubConfig } = getConfigFor(
      SPLIT_FEATURES.DC_CONFIG
    )

    let digitalClubPromoFlag = false

    if (
      Array.isArray(data?.userSet?.data) &&
      String(data?.userSet?.data[0]?.tagId) ===
        String(digitalClubConfig?.offerTagId)
    ) {
      digitalClubPromoFlag = true
    }
    if (loading) {
      return <Loader />
    } else {
      if (hideOffer) {
        return null
      } else {
        return (
          <OfferWrapper data-testid="offer-details" id={this.props.id}>
            {digitalClubPromoFlag && (
              <DigitalClubPromo data-testid="DC-Promo-Offer-Details">
                <MemberIngestionDiv>
                  <LPIcon
                    alt="Digital Club"
                    width="1.125rem"
                    height="1.125rem"
                    src={digitalClubConfig?.iconUrl}
                  />
                  {digitalClubConfig?.pdpOfferLabel && (
                    <Text size="medium" color="#333333">
                      {digitalClubConfig?.pdpOfferLabel}
                    </Text>
                  )}
                </MemberIngestionDiv>
                {!data?.isDBMember && (
                  <RedeemLabelDiv
                    onClick={event => {
                      Router.push('/membership/registration')
                      event.stopPropagation()
                    }}
                  >
                    <Text size="medium" color="#1557BF" weight="bold">
                      {digitalClubConfig?.joinToRedeemLabel}
                    </Text>
                  </RedeemLabelDiv>
                )}
              </DigitalClubPromo>
            )}
            {offer && offer.description && (
              <OfferHeading>
                <Text
                  color={defaultTheme.ColorBaseBrandSecondary500}
                  weight="bold"
                >
                  {this.state.offer.description}
                </Text>
              </OfferHeading>
            )}
            {freeProducts && freeProducts.length > 0 ? (
              <FreeProductsWrapper data-testid="free-products">
                <Carousel>
                  {freeProducts.map((product, index) => {
                    return (
                      <FreeProduct key={index}>
                        <Link
                          href={`/productDetails?slug=${product?.slug}`}
                          as={`/product/${product?.slug}`}
                          prefetch={false}
                          passHref
                        >
                          {product.images && product.images.length > 0 && (
                            <FreeProductImageContainer>
                              <img
                                alt={product.name ? product.name : ' '}
                                src={product.images[0]}
                              />
                            </FreeProductImageContainer>
                          )}
                          {product.name && (
                            <FreeProductStyledText>
                              {product.name}
                            </FreeProductStyledText>
                          )}
                        </Link>
                      </FreeProduct>
                    )
                  })}
                </Carousel>
              </FreeProductsWrapper>
            ) : null}
            {buyCategories && !isEmpty(buyCategories) && (
              <div data-testid="buy-categories">
                <ProductCollection
                  data={{ ...buyCategories }}
                  hideSeeAllButton
                  config={{
                    layoutType: 'SCROLLER',
                    loadMoreType: 'SEEALL',
                    loc: LOC_OFFERS,
                    pageType: this.props.pageType || undefined,
                    ctaSublocation: ['offers'],
                  }}
                />
              </div>
            )}
            {buyBrands && !isEmpty(buyBrands) && (
              <div data-testid="buy-brands">
                <ProductCollection
                  data={{ ...buyBrands }}
                  hideSeeAllButton
                  config={{
                    layoutType: 'SCROLLER',
                    loadMoreType: 'SEEALL',
                    loc: LOC_OFFERS,
                    pageType: this.props.pageType || undefined,
                    ctaSublocation: ['offers'],
                  }}
                />
              </div>
            )}
            {buyProducts &&
              buyProducts.collection &&
              buyProducts.collection.product &&
              buyProducts.collection.product.length > 0 && (
                <ProductCollection
                  data={{ ...buyProducts }}
                  hideSeeAllButton
                  config={{
                    layoutType: 'SCROLLER',
                    loadMoreType: 'SEEALL',
                    loc: LOC_OFFERS,
                    pageType: this.props.pageType || undefined,
                    ctaSublocation: ['offers'],
                  }}
                />
              )}
            {buyTags && !isEmpty(buyTags) && (
              <div data-testid="buy-tags">
                <ProductCollection
                  data={{ ...buyTags }}
                  hideSeeAllButton
                  config={{
                    layoutType: 'SCROLLER',
                    loadMoreType: 'SEEALL',
                    loc: LOC_OFFERS,
                    pageType: this.props.pageType || undefined,
                    ctaSublocation: ['offers'],
                  }}
                />
              </div>
            )}
          </OfferWrapper>
        )
      }
    }
  }
}

export default OfferDetails
